import { render, staticRenderFns } from "./PricingBandAssignPortal.vue?vue&type=template&id=24d544b2&scoped=true&"
import script from "./PricingBandAssignPortal.vue?vue&type=script&lang=js&"
export * from "./PricingBandAssignPortal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d544b2",
  null
  
)

export default component.exports